import React from "react";
import Panel from "../Panel/Panel.jsx";
import Button from "../Button/Button.jsx";

/**
 * In-app replacement for window.confirm - shows the details of what's about
 * to be deleted (children) and, on failure, the server's reason inline
 * instead of a separate toast, so the user sees why right where they acted.
 */
const ConfirmModal = ({
  open,
  title = "Are you sure?",
  children,
  confirmLabel = "Delete",
  cancelLabel = "Cancel",
  danger = true,
  loading = false,
  error = "",
  onConfirm,
  onCancel,
}) => {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 bg-[rgba(15,23,42,0.55)] backdrop-blur-[2px] flex items-center justify-center z-[200] p-4"
      onClick={onCancel}
    >
      <Panel
        padded
        className="w-full max-w-[420px] !p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="font-disp text-xl text-center mb-3 break-words">{title}</h3>

        <div className="text-[15px] text-center text-[var(--muted)] mb-5 break-words">{children}</div>

        {error && (
          <div className="text-[13px] text-center text-[var(--danger)] bg-[color-mix(in_srgb,var(--danger)_10%,transparent)] border border-[color-mix(in_srgb,var(--danger)_35%,transparent)] rounded-[10px] px-3 py-2 mb-4 break-words">
            {error}
          </div>
        )}

        <div className="flex gap-2.5">
          {error ? (
            <Button variant="ghost" className="flex-1" onClick={onCancel}>
              Close
            </Button>
          ) : (
            <>
              <Button variant="ghost" className="flex-1" onClick={onCancel} disabled={loading}>
                {cancelLabel}
              </Button>
              <Button
                variant={danger ? "danger" : "primary"}
                className="flex-1"
                onClick={onConfirm}
                disabled={loading}
              >
                {loading ? "Deleting…" : confirmLabel}
              </Button>
            </>
          )}
        </div>
      </Panel>
    </div>
  );
};

export default ConfirmModal;
